import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, LL_V_L, performAction, TS_Input, TS_Table } from '@nu-art/thunderstorm-frontend/index';
import './Editors.scss';
import { removeFromArrayByIndex } from '@nu-art/ts-common';
import { HCSDropDowns } from '../../../shared-components/index.js';
import { ICONS } from '@app/styles';
import { valueType_SubRange } from '@app/hcs-shared/core';
import { ModuleFE_MeasurementUnit, } from '../../../../_entity.js';
import { Dialog_EditMeasurementUnitSynonyms } from './Dialog_EditMeasurementUnitSynonyms.js';
export class CompoundRangeEditor extends ComponentSync {
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        if (!nextProps.value.data)
            nextProps.value.data = { subsets: [], scope: [0, 0], subsetIds: [] };
        state.units = ModuleFE_MeasurementUnit.cache.all();
        state.validFullRange = this.isValidFullRange(nextProps.value.data?.scope);
        state.fullRangeString = this.getFullRangeString(nextProps.value.data.scope) || '';
        if (!state.newInnerValues)
            state.newInnerValues = [];
        return state;
    }
    // ######################## Logic ########################
    onFullRangeStringChange = (fullRangeString) => {
        const minMax = this.parseRangeString(fullRangeString);
        //If min or max could not be parsed
        if (!minMax)
            return;
        this.props.value.data.scope = minMax;
        const valid = this.isValidFullRange(minMax);
        this.setState({
            validFullRange: valid,
            fullRangeString: valid ? this.getFullRangeString(minMax) : fullRangeString,
        }, this.forceUpdate);
    };
    parseRangeString = (rangeStr) => {
        const [min, max] = rangeStr.split('-').map(item => item.trim()).map(item => Number(item));
        //If min or max could not be parsed
        if ((!min && min !== 0) || (!max && max !== 0))
            return;
        return [min, max];
    };
    getFullRangeString(fullRange) {
        return `${fullRange[0]} - ${fullRange[1]}`;
    }
    isValidFullRange(fullRange) {
        if (!fullRange)
            return false;
        return fullRange[0] < fullRange[1];
    }
    onFullRangeMinMaxChange = (newMinMax, pos) => {
        const fullRange = this.props.value.data.scope;
        fullRange[(pos === 'min' ? 0 : 1)] = Number(newMinMax);
        this.setState({
            validFullRange: this.isValidFullRange(fullRange),
            fullRangeString: this.getFullRangeString(fullRange),
        });
    };
    getTableHeaders = () => {
        return [...['Label', 'Range', 'Min Value', 'Max Value'].map(i => ({
                header: i,
                widthPx: 150
            })), { header: 'Delete', widthPx: 30 }];
    };
    onCreateMeasurementUnit = async (text, items) => {
        // this change was applied due to incorrect approach thinking that we cannot allow creating new units when the adapter still has options
        // this is incorrect due to the fact that sometimes results may come up but be irrelevant so I switched to this check
        const duplicate = items.find(mUnit => mUnit.unitAsString.toLowerCase().trim() === text.trim().toLowerCase());
        if (duplicate)
            return;
        const titles = {
            inProgress: 'Creating New Measurement Unit',
            success: 'Measurement Unit Created',
            failed: 'Measurement Unit Creation Failed'
        };
        await performAction(async () => {
            const unit = {
                unitAsString: text,
                units: [text]
            };
            const newUnit = await ModuleFE_MeasurementUnit.v1.upsert(unit).executeSync();
            this.props.value.data.measurementUnit = newUnit;
            this.forceUpdate();
        }, { type: 'notification', notificationLabels: titles });
    };
    // ######################## Render ########################
    renderAddNewRangedButton = () => {
        return _jsx("div", { onClick: () => {
                this.state.newInnerValues.push({ type: valueType_SubRange, data: { scope: [0, 0] } });
                this.forceUpdate();
            }, className: 'add-value-button unselectable', tabIndex: 0, children: "Add Ranged Value" });
    };
    renderFullRange = () => {
        return _jsxs(LL_V_L, { className: 'dialog__main__section-item', children: [_jsx("div", { className: 'dialog__field-title', children: "Full Range" }), _jsxs(LL_H_C, { className: 'match_width full-range', children: [_jsx("div", { className: 'title', children: "Full Range" }), _jsx(TS_Input, { className: 'range-full', type: 'text', value: this.state.fullRangeString, onChange: this.onFullRangeStringChange }), _jsx(TS_Input, { className: 'range-min', type: 'number', value: String(this.props.value.data?.scope[0]), onChange: value => this.onFullRangeMinMaxChange(value, 'min') }), _jsx(TS_Input, { className: 'range-max', type: 'number', value: String(this.props.value.data?.scope[1]), onChange: value => this.onFullRangeMinMaxChange(value, 'max') })] })] });
    };
    renderUnitsDropDown = () => {
        const data = this.props.value.data;
        return _jsxs(LL_H_C, { className: 'dialog__main__section-item', children: [_jsx("div", { className: 'dialog__field-title', children: "Units" }), _jsx(HCSDropDowns.MeasurementUnit, { selected: data.measurementUnit, onSelected: (units) => {
                        this.props.value.data.measurementUnit = units;
                        this.forceUpdate();
                    }, onNoMatchingSelectionForString: this.onCreateMeasurementUnit }), data.measurementUnit && _jsx(ICONS.edit.component, { className: 'clickable', onClick: () => Dialog_EditMeasurementUnitSynonyms.show(data.measurementUnit, (updatedUnit) => {
                        this.props.value.data.measurementUnit = updatedUnit;
                        this.forceUpdate();
                    }) })] });
    };
    renderInnerValues = () => {
        const values = [...this.state.newInnerValues, ...this.props.value.data?.subsets || []];
        return _jsxs(LL_V_L, { className: 'dialog__main__section-item inner-values', children: [_jsxs(LL_H_C, { className: 'match_width', style: { justifyContent: 'space-between' }, children: [_jsx("div", { className: 'dialog__field-title', children: "Inner Values" }), this.renderAddNewRangedButton()] }), _jsx(LL_H_C, { className: 'match_width inner-values', children: _jsx(TS_Table, { header: this.getTableHeaders(), rows: values, headerRenderer: header => header === 'Delete' ? '' : header, cellRenderer: (prop, item, index) => {
                            switch (prop) {
                                case 'Label':
                                    return this.renderInnerValueLabel(item);
                                case 'Range':
                                    return this.renderInnerValueRange(item);
                                case 'Min Value':
                                    return this.renderInnerValueMin(item);
                                case 'Max Value':
                                    return this.renderInnerValueMax(item);
                                case 'Delete':
                                    return this.renderValueActions(item);
                                default:
                                    return '';
                            }
                        } }) })] });
    };
    renderInnerValueLabel = (value) => {
        return _jsx(TS_Input, { type: 'text', placeholder: 'Enter label for value', className: 'inner-values__label', value: value.data?.label, onChange: str => {
                value.data.label = str;
                this.forceUpdate();
            } });
    };
    renderInnerValueRange = (value) => {
        return _jsx(TS_Input, { type: 'text', value: this.getFullRangeString(value.data.scope), onChange: newVal => {
                const minMax = this.parseRangeString(newVal);
                if (!minMax)
                    return;
                //Changing regular scope value
                value.data.scope = minMax;
                this.forceUpdate();
            } });
    };
    renderInnerValueMin = (value) => {
        return _jsx(TS_Input, { type: 'number', value: String(value.data.scope[0]), onChange: newVal => {
                //Changing regular scope value
                value.data.scope[0] = Number(newVal);
                this.forceUpdate();
            } });
    };
    renderInnerValueMax = (value) => {
        return _jsx(TS_Input, { type: 'number', value: String(value.data.scope[1]), onChange: newVal => {
                //Changing regular scope value
                value.data.scope[1] = Number(newVal);
                this.forceUpdate();
            } });
    };
    renderValueActions = (value) => {
        if (!this.state.newInnerValues.includes(value)) {
            const index = this.props.value.data.subsets.indexOf(value);
            return _jsx(LL_H_C, { className: 'inner-values__actions', children: _jsx(ICONS.bin.component, { className: 'inner-values__actions__delete', onClick: () => {
                        removeFromArrayByIndex(this.props.value.data.subsets, index);
                        this.forceUpdate();
                    } }) });
        }
        const index = this.state.newInnerValues.indexOf(value);
        return _jsxs(LL_H_C, { className: 'inner-values__actions', children: [_jsx(ICONS.x.component, { className: 'inner-values__actions__cancel', onClick: () => {
                        removeFromArrayByIndex(this.state.newInnerValues, index);
                        this.forceUpdate();
                    } }), _jsx(ICONS.v.component, { className: 'inner-values__actions__accept', onClick: () => {
                        this.props.value.data.subsets.push(this.state.newInnerValues.splice(index, 1)[0]);
                        this.forceUpdate();
                    } })] });
    };
    render() {
        return _jsx(LL_H_C, { className: 'dialog__main', children: _jsxs(LL_V_L, { className: 'dialog__main__section compound-range-editor', children: [this.renderUnitsDropDown(), this.renderFullRange(), this.renderInnerValues()] }) });
    }
}
//# sourceMappingURL=CompoundRangeEditor.js.map